// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.item-name[data-v-54c4b975] {\n  padding-bottom: 0px !important;\n}\n", ""]);
// Exports
module.exports = exports;
